<template>
  <div>
    <div small>
      <v-card class="px-4" flat>
        <v-layout wrap>
          <v-flex xs12 v-for="(language, key) in languages" :key="key">
            <v-layout wrap>
              <v-flex xs4>
                <v-select
                  v-model="language.code"
                  :label="$t('1')"
                  :items="availableLanguages"
                  item-text="text"
                  item-value="isoCode"
                  outlined
                  dense
                ></v-select>
              </v-flex>
              <v-flex xs1></v-flex>
              <v-flex xs4>
                <v-select
                  v-model="language.level"
                  :label="$t('2')"
                  :items="allLevels"
                  item-text="text"
                  item-value="value"
                  outlined
                  dense
                ></v-select>
              </v-flex>
              <v-flex xs1></v-flex>
              <v-flex xs2 pt-1>
                <v-btn fab @click="removeLanguage(language.code)" x-small elevation="0">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-btn @click="addLanguage" outlined small>
          <v-icon left small>mdi-plus</v-icon>
          {{ $t('3') }}
        </v-btn>
      </v-card>
    </div>
  </div>
</template>

<script>
const allLanguages = require('@/assets/app/data/languages.json').filter(l => l.iso_code)
const textkernelLanguageLevels = require('@/assets/app/data/textkernelLanguageLevels.json')

import { mapGetters } from "vuex";

export default {
  props: {
    profile: Object
  },
  data: () => ({
    languages: [],
    originalLanguages: null
  }),
  mounted() {
    this.originalLanguages = JSON.parse(JSON.stringify(this.profile.languages))
    // Fill languages from profile
    this.languages = this.profile.languages.map(language => {
      return {
        code: language.code || this.availableLanguages.find(l => l.text === language.name).isoCode, // last part (after || ) is made for backward compatibility
        level: language.levelNb
      }
    })
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    availableLanguages() {
      return allLanguages.map(l => {
        return { 'isoCode': l.iso_code, 'text': l.descriptions[this.user.data.locale] }
      })
      .sort((a,b) => (a.text > b.text ? 1 : -1))
    },
    allLevels() {
      const allLevels = [ { value: null, text: "" } ]
      for (let x of textkernelLanguageLevels) {
        allLevels.push({
          value: x['levelNb'],
          text: x[this.user.data.locale]
        })
      }
      return allLevels
    }
  },
  methods: {
    addLanguage() {
      this.languages.push({
        level: null,
        code: null
      })
    },
    removeLanguage(languageCode) {
      this.languages = this.languages.filter(language => language.code !== languageCode)
    }
  },
  watch: {
    languages: {
      handler() {
        this.profile.languages = this.languages.filter(language => language.code).map(language => {
          return {
            level:  language.level !== null ? textkernelLanguageLevels.find(lang => lang.levelNb === language.level)[this.profile.cvLanguage === 'UNKNOWN' ? 'en' : this.profile.cvLanguage.toLowerCase()] : '',
            levelNb: language.level,
            name: language.code ? allLanguages.find(lang => lang.iso_code === language.code).descriptions[this.profile.cvLanguage === 'UNKNOWN' ? 'en' : this.profile.cvLanguage.toLowerCase()] : '',
            code: language.code
          }
        })
      },
      deep: true
    }
  }
}
</script>


<i18n>
{
  "fr": {
    "1": "Langue",
    "2": "Niveau",
    "3": "Ajouter une langue"
  },
  "en": {
    "1": "Language",
    "2": "Level",
    "3": "Add a language"
  }
}
</i18n>